module.exports = __webpack_public_path__ + "static/top_home-6d47564e60938a640ebfec2809bb0935.jpg";